import { Group, rem, Stack, Text } from '@mantine/core';
import { CapChartValueIndicator } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/CapChartValueIndicator.tsx';
import type { CapChartEdgeLabelValue } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/chart.model.ts';
import { CAP_TABLE_VALUES_HELD_TYPE } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/tableSettings.ts';
import { makeComplexDataTestId, TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds.ts';

interface Props {
	values: CapChartEdgeLabelValue[];
}

export const CapChartEdgeLabel = ({ values }: Props) => (
	<Group gap={4} wrap="nowrap" align="flex-start">
		<Stack gap={4}>
			{values.map(({ valuesHeldType }) => (
				<CapChartValueIndicator key={valuesHeldType} valuesHeldType={valuesHeldType} />
			))}
		</Stack>
		<Stack gap={4} align="flex-end">
			{values.map(({ valuesHeldType, text }) => (
				<Text
					key={valuesHeldType}
					fz="sm"
					fw={600}
					lh={rem(16)}
					style={{ whiteSpace: 'nowrap' }}
					data-testid={makeComplexDataTestId(
						valuesHeldType === CAP_TABLE_VALUES_HELD_TYPE.VOTES
							? TEST_ELEMENT_IDS.GSC_EDGE_LABEL_VOTES
							: TEST_ELEMENT_IDS.GSC_EDGE_LABEL_UNITS,
						text
					)}
				>
					{text}
				</Text>
			))}
		</Stack>
	</Group>
);
